import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { useIntl } from 'react-intl'
import { timePlaceholder, timeFormat } from 'src/services/intl'

/**
 * Localized time
 */
const LocalizedTime = ({ placeholder, value, children, ...props }) => {
  const intl = useIntl()
  const text = isNil(value) ? placeholder : intl.formatTime(value, { ...timeFormat, ...props })
  return children ? children(text) : <span title={text}>{text}</span>
}

LocalizedTime.defaultProps = {
  placeholder: timePlaceholder,
}

LocalizedTime.propTypes = {
  placeholder: PropTypes.node,
  value: PropTypes.any,
  children: PropTypes.func,
}

export default LocalizedTime
